<template>
    <div class="editform">
        <Form ref="dInfo"
            :model="dInfo"
            :rules="ruleValidate"
            :label-width="90">
            <FormItem label="分类名称"
                prop="name">
                <Input v-model="dInfo.name"
                    :maxlength="32"></Input>
            </FormItem>
            <FormItem label="分类代码"
                prop="code">
                <Input v-model="dInfo.code"
                    :maxlength="32"></Input>
            </FormItem>
            <FormItem label="是否系统内置"
                prop="sys">
                <Select v-model="dInfo.sys"
                    transfer>
                    <Option v-for="(item, index) in sysList"
                        :value="item.id"
                        :key="index">{{item.text}}</Option>
                </Select>
            </FormItem>
        </Form>
    </div>
</template>
<script>
import {
    dictUpdate,
    dictView
} from '@/api/sys-dict'
import Enum from '_u/enum'

const syss = Enum.get("yesOrNo")

export default {
    name: 'dictForm',
    props: {
        pid: {
            type: [String, Number],
            default: ''
        },
        id: {
            type: [String, Number],
            default: ''
        },
        ver: {
            type: [String, Number],
            default: ''
        },
        prodId: {
            type: [String, Number],
            default: ''
        }
    },
    components: {

    },
    inject: {
        $modal: {
            default: null
        }
    },
    data() {
        return {
            dInfo: {
                id: '',
                name: '',
                code: '',
                pid: '',
                ver: '',
                sys: syss.No
            },

            ruleValidate: {
                name: [{
                    required: true,
                    message: '分类名称必填',
                    trigger: 'blur'
                }],
                code: [{
                    required: true,
                    message: '分类代码必填',
                    trigger: 'blur'
                }]
            }
        }
    },
    computed: {
        sysList: function() {
            return syss.toList()
        }
    },
    methods: {
        fetch() {
            return dictView(this.id)
                .then(res => {
                    var resData = res.data
                    this.dInfo.name = resData.name
                    this.dInfo.code = resData.code
                })
        },

    },
    mounted() {

        var $dInfo = this.$refs.dInfo

        this.$modal.onBtnClick("confirm", (next, options) => {
            $dInfo.validate(valid => {
                if (valid) {
                    this.dInfo.pid = this.pid
                    this.dInfo.id = this.id
                    this.dInfo.ver = this.ver
                    this.dInfo.prodId = this.prodId
                    dictUpdate(this.dInfo)
                        .then(res => this.$Message.success(this.$t("tips.update.success")), err => options.closeModal = false)
                        .then(res => next())
                } else {
                    options.closeModal = false
                    next()
                }
            })
        })

        // 在窗口显示前加载数据
        this.$modal.beforeEnter((next) => {
            Promise.all([
                    this.fetch()
                ])
                .then(args => {
                    next()
                })
        })
    }
}
</script>